import { Router } from '@angular/router';
import { Student } from 'src/app/models/student';
import { LocalStrorageService } from './../../services/local-strorage.service';
import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { i18nLanguages } from '../../const/common';

declare var $: any;

@Component({
  selector: 'app-header-style-four',
  templateUrl: './header-style-four.component.html',
  styleUrls: ['./header-style-four.component.scss']
})
export class HeaderStyleFourComponent implements OnInit {
  student: Student;
  subscription: Subscription;
  route: string;
  exampages = ['/math1', '/math2', '/reading'];
  language = i18nLanguages.ru;

  constructor(private localStorageService: LocalStrorageService,
              private router: Router,
              private location: Location,
              private translate: TranslateService) {
    const lang = this.localStorageService.getLang();
    if (lang === 'rus') {
      this.language = i18nLanguages.ru;
    }
    router.events.subscribe(val => {
      if (!this.checkLocationIsExamPage(location.path())) {
        // tslint:disable-next-line: typedef
        $(window).on('scroll', function () {
          if ($(this).scrollTop() > 120) {
            $('.navbar-area').addClass('is-sticky');
          } else {
            $('.navbar-area').removeClass('is-sticky');
          }
        });
      }
    });
  }

  get isStudentLoggedIn(): boolean {
    const student = this.localStorageService.getStudent();
    if (student) {
      return true;
    }
  }

  ngOnInit(): void {
    this.student = this.localStorageService.getStudent();
  }

  checkLocationIsExamPage(location: string): boolean {
    return this.exampages.includes(location);
  }

  // TODO: change to good quality code
  logOut() {
    this.localStorageService.deleteStudent();
    this.student = this.localStorageService.getStudent();
    if (this.router.url !== '') {
      this.router.navigateByUrl('/');
    }
  }

  switchLang(lang: string, flag: string): void {
    this.translate.use(lang);
    if (lang === 'rus') {
      this.language.lan = 'Рус';
      this.language.flag = flag;
      this.localStorageService.setLang('rus');
    } else {
      this.language.lan = 'Кыр';
      this.language.flag = flag;
      this.localStorageService.setLang('kyr')
    }
  }

  ngOnDestroy() {
    this.subscription && this.subscription.unsubscribe();
  }
}
